'use strict';

var stage = require('../stage.cjs');
var useEnv = require('./useEnv.cjs');

const useStageEnv = () => {
  const { env } = useEnv.useEnv();
  const stage$1 = env.runtime.STAGE;
  const is = (target) => {
    return target === stage$1;
  };
  const isLocal = is(stage.StageEnv.Local);
  const isDev = is(stage.StageEnv.Dev);
  const isQA = is(stage.StageEnv.QA);
  const isProd = is(stage.StageEnv.Prod);
  return { is, stage: stage$1, isLocal, isDev, isQA, isProd };
};

exports.useStageEnv = useStageEnv;
//# sourceMappingURL=useStageEnv.cjs.map
